// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___299fx","innerTop":"style__innerTop___3_0uI","innerBottom":"style__innerBottom___2pAxd","formContainer":"style__formContainer___2VSEb","greeting":"style__greeting___ra9-R","title":"style__title___2z4AQ","desc":"style__desc___30IRe","nameLabel":"style__nameLabel___3fD0Z","errorText":"style__errorText___1M6sO","activeErrorText":"style__activeErrorText___HBLUD","button":"style__button___1diCv","birthdayContainer":"style__birthdayContainer___1LM5i","birthdayLabel":"style__birthdayLabel___21Ssh"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/ui/screens/profile-info/style.css
// module id = 848
// module chunks = 0